'use strict';

const FieldTextBoxModel = require('components/ui/field_text_box/js/model');

module.exports = FieldTextBoxModel.extend({
    setValidationRegExp(validationRegExp) {
        this.validationRegExp = new RegExp(validationRegExp);
    },
    initialize() {
        this.name = 'nameoncard';
        FieldTextBoxModel.prototype.initialize.call(this);
    },
    update(data) {
        this.set('value', data.nameoncard);
    },
    validate(attrs = this.toJSON()) {
        let error;
        const cardNameRegExp = this.validationRegExp;
        const cardName = attrs.value;
        if (Odigeo._.isEmpty(cardName)) {
            error = 'empty';
        } else if (cardNameRegExp instanceof RegExp && !cardNameRegExp.test(cardName)) {
            error = 'invalid';
        }

        return error;
    },
});
